import { initDropdownUser } from "../utilities/dropdownToggle";
const debounce = require("lodash/debounce");
const { refreshStickyWrapperHeight } = require("../utilities/stickyHelpers");
const mqueryRespond = window.mqRespond;
const scrollLock = require("../utilities/scrollLock");

$(document).ready(function () {
    const pid = window.sessionStorage.getItem("wishlist-quickview-pid");

    if (pid) {
        const targetPid = $(`[data-pid='${pid}']`);
        const quickviewClassName = window.sessionStorage.getItem("wishlist-quickview-classname");
        const currentTarget = targetPid.find("." + quickviewClassName.trim().replace(/ /g, "."));
        if (currentTarget.length > 0) {
            currentTarget[0].click();
        }
        window.sessionStorage.removeItem("wishlist-quickview-classname");
        window.sessionStorage.removeItem("wishlist-quickview-pid");
    }
});

const showInformativeCouponsToast = () => {
    const getModalContentURL = $(".js-mod-url").data("url");

    if (getModalContentURL) {
        $.ajax({
            url: getModalContentURL,
            type: "get",
            dataType: "html",
            data: {
                template: "components/popupToast"
            },
            success: data => {
                $(".couponToastContainer").append($(data)).ready(() => $(".couponToast").fadeIn());

                setTimeout(function () {
                    $(".couponToastContainer").remove($(data)).ready(() => $(".couponToast").fadeOut());
                }, 5000);

            },
        });
    }
};

const stickyHeaderInit = () => {
    const $html = $("html");
    const $body = $("body");
    const $stickyElem = $(".sticky-element");
    const $window = $(window);
    let scrollDirection;
    let currentScrollTop = $window.scrollTop();
    let previousScrollTop = currentScrollTop;

    const checkIfSticky = () => {
        currentScrollTop = $window.scrollTop();

        if (currentScrollTop > previousScrollTop && scrollDirection !== 1) {
            scrollDirection = 1;
        } else if (currentScrollTop < previousScrollTop && scrollDirection !== -1) {
            scrollDirection = -1;
        }

        $stickyElem.each(function (i, e) {
            const $element = $(e);
            const $stickyWrapper = $element.parent();
            const $stickyBanner = $(document).find(".sticky-banner:not(.d-none)");
            const _stickyWrapper = $stickyWrapper[0];
            const _topPosition = parseFloat(_stickyWrapper.getBoundingClientRect().top);
            const existingStickyHeight = $stickyBanner.length && !$element.is($stickyBanner) ? parseFloat($stickyBanner.outerHeight(true)) : 0;
            const scrollUp = scrollDirection == -1;
            const scrollDown = scrollDirection != -1;
            const isHeaderSimplified = $("header").hasClass("simplified-header");

            // Specific for header sticky functionality
            // Make the header absolute and keep its position as it was when the nav is opened
            // Making the scroll in page possible to see all the category from nav
            if (!isHeaderSimplified && $element.parents("header").length && (mqueryRespond.status.desktop || mqueryRespond.status.desktopLarge)) {
                const topLinksHeight = parseFloat($(".header-util").outerHeight(true));
                const topOfWindow = parseInt(existingStickyHeight, 10) + currentScrollTop;
                const elementPos = currentScrollTop == 0 ? $element[0].getBoundingClientRect().top + currentScrollTop - topLinksHeight : $element[0].getBoundingClientRect().top + currentScrollTop;
                const scrollAboveHeader = elementPos > topOfWindow;

                if (scrollDown && $(".d-navigation-open").length && !$element.hasClass("sticky-paused")) {
                    $element.css("top", topOfWindow).addClass("sticky-paused");
                    previousScrollTop = currentScrollTop;
                    return;
                } else if (scrollUp && scrollAboveHeader) { $element.removeClass("sticky-paused"); }

                if ($element.hasClass("sticky-paused")) { previousScrollTop = currentScrollTop; return; }
            }

            if (_topPosition < existingStickyHeight && !scrollLock.isEnabled()) {
                $html.addClass("sticky-navigation");
                $element.css("top", parseInt(existingStickyHeight, 10));
                $element.addClass("is-sticky");
            } else {
                if (!$body.hasClass("modal-open")) {
                    $element.removeClass("is-sticky");
                    if (!$(".is-sticky").length) { $html.removeClass("sticky-navigation"); }
                }
            }

            previousScrollTop = currentScrollTop;
        });
    };

    if ($stickyElem.length) {
        $window.on("load", function () {
            refreshStickyWrapperHeight();
            checkIfSticky();
        }).on("scroll", checkIfSticky).on("resize", debounce(function () {
            refreshStickyWrapperHeight();
        }, 500));
    }
};

/**
 * @function
 * @description - Adjust suggestions wrapper height, which depends on the presence of the promo banner and on the sticky elements dimensions
 */
var adjustSuggestionsWrapperHeight = () => {
    const SEARCH_WRAPPER_TOP_PADDING = 15;
    var stickyElementsHeight = $(".header-wrapper").height() + $(".js-header-banner").height() + $(".search-field").height() - SEARCH_WRAPPER_TOP_PADDING,
        $searchSuggestions = $(".search-mobile");

    if (mqueryRespond.status.mobile) {
        $searchSuggestions.css("max-height", $(window).innerHeight()).css("max-height", `-=${stickyElementsHeight}px`);
    } else {
        $searchSuggestions.removeAttr("style");
    }
};

const init = () => {
    const $userDiv = $(".user");
    const $userSubMenu = $userDiv.find(".popover");
    const $userNavItem = $(".user.nav-item.d-block");
    const $minicart = $(".minicart");
    const $minicartPopover = $minicart.find(".ct-popover");
    const $minicartIsOpen = $minicartPopover.hasClass("show");
    const $stickyShadows = $(".sticky-element.navigation-shadows");
    const isUserAuthenticated = $(".ct-user-dropdown--authenticated").length;
    const queryStringParams = new URLSearchParams(window.location.search);

    if (window.location.search.includes("isMobileApp=true")) {
        if (!document.cookie.includes("mobileAppData")) {
            const getMobileAppValidationURL = $(".js-mobile-app-validation").data("url");
            $.ajax({
                url: getMobileAppValidationURL,
                type: "get",
                dataType: "json",
                success: data => {
                    if (data.success) {
                        let reloadUrl = window.location.href.split("?")[0];
                        queryStringParams.delete("isMobileApp");
                        if (queryStringParams.toString().length > 0) {
                            reloadUrl += "?" + queryStringParams.toString();
                        }
                        window.location.href = reloadUrl;
                    }
                },
            });
        }
    }

    if (window.location.search.includes("withCoupons=true")) {
        queryStringParams.delete("withCoupons");

        if (isUserAuthenticated) {
            showInformativeCouponsToast();
        }
    }
    
    if (window.location.search.includes("avReset=true")) {
        queryStringParams.delete("avReset");
        window.localStorage.setItem("chatSessionID", "reset");
    }

    let newUrl = window.location.href.split("?")[0];
    if (queryStringParams.toString().length > 0) {
        newUrl += "?" + queryStringParams.toString();
    }
    try {
        window.history.replaceState(
            {},
            document.title,
            newUrl
        );
    } catch (error) {
        if (error) {
            console.error(error); // eslint-disable-line
        }
    }

    if (window.location.pathname.includes("Account-Show") && !$minicartIsOpen) {
        $userNavItem.addClass("is-logged-header-menu");
        $stickyShadows.addClass("navigation-shadows-profile");
    }

    if ((mqueryRespond.status.desktop || mqueryRespond.status.desktopLarge) && $userDiv.length > 0) {
        initDropdownUser($userDiv, $userSubMenu);

        $("body").on("click", e => {
            const $userLoginWrapper = $(".user-login");
            const $userLoginTrigger = $userLoginWrapper.find(".user");
            const $userDropdownToggle = $userLoginWrapper.find(".js-user-dropdown-toggle");
            const awaitingTrigger = $("body").hasClass("awaiting-trigger");

            if (!$userLoginWrapper.has(e.target).length && !awaitingTrigger && $userLoginTrigger.hasClass("ct-user-dropdown--shown")) {
                $("body").addClass("awaiting-trigger");
                $userDropdownToggle.trigger("click");
                $("body").removeClass("awaiting-trigger");
            }
        });
    }

    adjustSuggestionsWrapperHeight();

    $(".js-brand-nav-link").on("click", function (e) {
        const brand = {
            OPEN_BRAND_TAB: e.currentTarget.href
        };

        //Iframe
        if (window.top) {
            window.top.postMessage(brand, "*");
        }

        //Cordova
        if (window.webkit !== undefined) {
            window.webkit.messageHandlers.cordova_iab.postMessage(
                JSON.stringify(brand)
            );
        }
    });

    function preventDefaultAction(event) {
        event.preventDefault();
    }

    const quickDeliveryLinks = document.querySelectorAll(".js-quick-delivery-link");
    quickDeliveryLinks.forEach(link => {
        //on all links, prevent default
        link.addEventListener("click", preventDefaultAction);
    });

    window.addEventListener("load", () => {
        quickDeliveryLinks.forEach(link => {
            //on all links, prevent default
            link.removeEventListener("click", preventDefaultAction);
        });
    });

    stickyHeaderInit();
};

module.exports = {
    init: init,
    stickyHeaderInit: stickyHeaderInit
};
